
import React, { useContext } from "react";
import { FaLeaf, FaGlobe, FaRecycle, FaSeedling } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ConsultancyGlobal.css';
import BannerImage from './consultancy_hero.png';

function ISO14001Cons() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-14001-consultancy');
    } else {
      navigate('/login', { state: { from: '/booking/iso-14001-consultancy' } });
    }
  };

  return (
    <div className="consultancy-page">
      <div className="consultancy-max-width">

        {/* --- HERO --- */}
        <div className="consultancy-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Sustainability</span>
          <h1 className="hero-title">ISO 14001 Consultation</h1>
          <p className="hero-subtitle">
            Partnering with you to achieve environmental sustainability.
            Reduce waste, comply with regulations, and build a greener future.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Consulted <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Environmental Stewardship</h2>
              <p className="article-text">
                ISO 14001 helps organizations manage their environmental responsibilities.
                It is not just about following rules; it acts as a framework for better environmental performance.
                We help you identify your environmental aspects and impacts, from energy use to waste generation.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Compliance & Strategy</h2>
              <p className="article-text">
                Navigating environmental laws can be daunting. We ensure your Environmental Management System (EMS)
                is robust, compliant, and integrated into your business strategy. This reduces the risk of liability
                and prepares you for a low-carbon economy.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Implementation Steps</h2>
              <p className="article-text">
                1. <strong>Review:</strong> Analyze current environmental footprint.<br />
                2. <strong>Design:</strong> Create an EMS tailored to your industry.<br />
                3. <strong>Train:</strong> Educate employees on green practices.<br />
                4. <strong>Monitor:</strong> Set targets for waste reduction and energy savings.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Green Benefits</h4>
              <ul className="key-list">
                <li><FaLeaf className="check-icon" /> Reduced Waste Costs</li>
                <li><FaGlobe className="check-icon" /> Regulatory Compliance</li>
                <li><FaRecycle className="check-icon" /> Circular Economy Ready</li>
                <li><FaSeedling className="check-icon" /> Enhanced Corporate Image</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Certify Green</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Join the sustainable revolution.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO14001Cons;
